import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import PropTypes from "prop-types";

PhoneStartMode.propTypes = {
    enablePhoneMode: PropTypes.func.isRequired,
}

export default function PhoneStartMode(props) {
    return (
        <div className="page">
            <AppHeader title="Mobiel"/>
            <h1 className="phone-pick-title">Offerte aanvraag voor uw mobiel.<br/>Klik op de knop hieronder om te beginnen.</h1>

            <div className="page-middle" style={{display: "flex", justifyContent: "center"}}>
                <button className="start-phone-button" onPointerUp={props.enablePhoneMode}>Start offerte aanvraag</button>
            </div>
        </div>
    );
}
